import { render, staticRenderFns } from "./TableMonthCat.vue?vue&type=template&id=5081482c&"
import script from "./TableMonthCat.vue?vue&type=script&lang=js&"
export * from "./TableMonthCat.vue?vue&type=script&lang=js&"
import style0 from "./TableMonthCat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports